import React, { useState } from "react";

const ApplicationProcedureAIR = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Application Procedure",
      content: `Prospective students are required to submit a completed application form, along with academic transcripts, a curriculum vitae (CV), & a statement of purpose outlining their interest in the program. The admissions committee evaluates applicants based on their academic background, relevant experience, & motivation for pursuing the course.`,
    },
    {
      id: 2,
      title: "Programme Cost",
      content: `The course fee for the Advanced International Relations & Diplomatic Practice Course is €850.

       You can choose to pay the full programme fee of €850 upfront, which also grants you exclusive access to a leadership webinar with an international expert. 
       
       Alternatively, you can opt for the instalment plan, which consists of two bi-monthly payments of €425 each.`,
    },
  ];

  return (
    <div
      className="md:scroll-mt-44 scroll-mt-16 my-10"
      id="application-procedure"
    >
      <div className="bg-gradient-to-r from-gray-600 to-blue-950 py-10">
        <div className="max-w-6xl mx-auto px-10 space-y-8">
          <h2 className="text-2xl font-extrabold text-center mb-6 text-white">
            Application Procedure & Programme Cost
          </h2>
          <div className="bg-sdbodywhiteywhitebody h-1 w-20 mx-auto rounded"></div>
          <div className="space-y-4">
            {sections.map((section) => (
              <div
                key={section.id}
                className="border border-gray-300 rounded-lg overflow-hidden shadow-lg"
              >
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-4 px-5 bg-blue-100 hover:bg-blue-200 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-lg text-gray-700">
                      {section.title}
                    </span>
                    <span className="text-gray-600">
                      {activeSection === section.id ? "▲" : "▼"}
                    </span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-5 py-4 bg-sdbodywhiteywhitebody">
                    <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcedureAIR;
